import { Link, Text, TextProps } from '@chakra-ui/react';
import { ELegalLinks } from '@olo-web/types/enums';

export const CheckoutDisclaimer = (props: TextProps) => {
  return (
    <Text textStyle="label" color="blackAlpha.400" {...props}>
      By placing your order, you agree to our{' '}
      <Link
        isExternal
        href={ELegalLinks.TERMS_OF_USE}
        textDecor="underline"
        aria-label="Terms of Use (opens in new window)"
      >
        Terms of Use
      </Link>{' '}
      and{' '}
      <Link
        isExternal
        href={ELegalLinks.PRIVACY_POLICY}
        textDecor="underline"
        aria-label="Privacy Policy (opens in new window)"
      >
        Privacy Policy
      </Link>
      .
    </Text>
  );
};
